import React from 'react'
import { Icon, List, Popup } from 'semantic-ui-react'

const CalculationListItem = ({
  header,
  value,
  tooltip,
  width,
}: {
  header: string
  value?: string | React.ReactElement | null
  tooltip?: React.ReactNode
  width?: string
}) => (
  <List.Item>
    <List.Content verticalAlign="middle" floated="right">
      {value}
      {tooltip && (
        // position keeps the flyout beside this dense list instead of covering sibling rows;
        // popper's semantic-ui-root class re-scopes it into our Semantic UI stylesheet, which
        // it otherwise loses once portaled outside that tree (see Modal.tsx for the same fix).
        <Popup
          hoverable
          position="right center"
          style={{ width: width ?? 300 }}
          popper={{ className: 'semantic-ui-root' }}
          flowing
          trigger={
            <Icon
              style={{ fontSize: '12px', margin: '0 0 0 5px' }}
              name="question circle"
            />
          }
          content={tooltip}
        />
      )}
    </List.Content>
    <List.Header style={{ color: 'grey' }}>{header}</List.Header>
  </List.Item>
)

export default CalculationListItem
